enum StorageKey {
  /** Stores the libp2p pub/priv key pair. */
  PeerId = 'farnsworth/peer-id',

  /** Stores WebRTC connection preferences.  */
  WebrtcSettings = 'farnsworth/webrtc-settings',
}

export default StorageKey;
